import { render, staticRenderFns } from "./famous_download.vue?vue&type=template&id=12323d7a&"
import script from "./famous_download.vue?vue&type=script&lang=js&"
export * from "./famous_download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports